import React from "react";
import PropTypes from "prop-types";
// import Redirects from "../../../data/redirectionMap";

export default class Category extends React.Component {
    render(){
        let idLink = `/categories/${this.props.id}`;
        let urlKey = (this.props.redirections || {})[idLink];

        if (!urlKey) {
            urlKey = idLink;
        }

        let link =  this.props.parent_id == "20" ? `/application${urlKey}` : `${urlKey}`;

        return(
            <div className="card">
                <div className="card-body" style={{textAlign: "center"}}>
                    <h2>
                        <a className="card-title" href={link}>
                            {this.props.name}
                        </a>
                    </h2>
                </div>
            </div>
        );
    }
}

Category.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    parent_id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    name: PropTypes.string,
    redirections: PropTypes.object
};
